// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-pages-index-tsx" + "-" + "a333f80b2f2abbfe0f60" + ".js";
};